export const DEFAULT_STARTING_DATE = "01/01/2022";
